import React, { PropsWithChildren, useEffect, useState } from 'react';
import { useStores } from '~/hooks';

/**
 * 初始化成员字段配置
 * 若组件内需要消费成员字段配置，则组件外层需要包裹MemberFieldProvider
 *
 * @param children
 * @constructor
 */
const MemberFieldProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const [isMemberFieldInit, setMemberFieldInit] = useState(false);

    const { corpUserStore, memberFieldStore } = useStores();

    useEffect(() => {
        memberFieldStore.init(corpUserStore).then(() => {
            setMemberFieldInit(true);
        });
    }, []);

    return isMemberFieldInit ? <>{children}</> : null;
};

export default MemberFieldProvider;
